import React, { useState } from 'react';
import { Col, Card, Modal, Form, Spinner } from 'react-bootstrap';
import { useLocation } from 'react-router';
import { ref, uploadBytes } from 'firebase/storage';
import swal from 'sweetalert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useAuth from '../../../hooks/useAuth';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import './DashboardSpecial.css';
import { useForm } from 'react-hook-form';


const DashboardSpecial = ({ special }) => {
    const [title, setTitle] = useState(special.title);
    const [description, setDescription] = useState(special.description);

    const [changedTitle, setChangedTitle] = useState(special.title);
    const [changedDescription, setChangedDescription] = useState(special.description);

    const [canApply, setCanApply] = useState(false);

    const location = useLocation();
    const { register, handleSubmit, reset, formState: { errors } } = useForm();

    const [modalShow, setModalShow] = useState(false);
    const [specialUpload, setSpecialUpload] = useState(null);
    const { storage } = useAuth();
    const [uploadPreview, setUploadPreview] = useState(special.url);
    const [currentSpecial, setCurrentSpecial] = useState(special.url);

    const [editLoading, setEditLoading] = useState(false);


    const uploadOnChange = (event) => {
        setCanApply(true);
        setSpecialUpload(event.target.files[0]);
        setUploadPreview(URL.createObjectURL(event.target.files[0]));
    }





    const onSubmit = data => {
        setEditLoading(true);
        if (specialUpload != null) {
            const specialRef = ref(storage, `specials/special${special.specialID}`);
            uploadBytes(specialRef, specialUpload)
                .then(() => {
                    setCurrentSpecial(uploadPreview);
                    setEditLoading(false);
                    if (title == changedTitle && description == changedDescription) {
                        swal("Changes Applied", "We have changed the special menu.", "success");
                        reset();
                        setModalShow(false);
                        setCanApply(false);
                    }
                });
        }
        if (title != changedTitle || description != changedDescription) {
            setEditLoading(true);
            data.specialID = special.specialID;
            data.url = currentSpecial;
            fetch(`https://gentle-tor-99938.herokuapp.com/specials/${special._id}`, {
                method: 'PUT',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            })
                .then(res => res.json())
                .then(result => {
                    if (result.modifiedCount) {
                        setTitle(data.title);
                        setDescription(data.description);
                        setModalShow(false);
                        swal("Changes Applied", "We have changed the special menu.", "success");
                        setCanApply(false);
                        reset();
                    }
                    else {
                        swal("Something Went Wrong!", "We couldn't save your menu. Please try again later", "error");
                    }
                })
                .finally(() => setEditLoading(false));
        }

    }


    const editChange = (e) => {
        const field = e.target.name;
        const value = e.target.value;

        if (field == 'title') {
            setChangedTitle(value);

            if (title == value && description == changedDescription) {
                setCanApply(false);
            }
            else {
                setCanApply(true);
            }
        }
        else if (field == 'description') {
            setChangedDescription(value);

            if (title == changedTitle && description == value) {
                setCanApply(false);
            }
            else {
                setCanApply(true);
            }
        }




    }


    return (
        <Col>
            <Card>
                <Card.Img variant="top" src={currentSpecial} />
                <Card.Body>
                    <Card.Title>{title}</Card.Title>
                    <Card.Text>
                        {description}
                    </Card.Text>
                </Card.Body>
                <button onClick={() => {
                    setModalShow(true)
                }} className="btn btn-lg btn-dark" style={{
                    borderRadius: 0
                }}>
                    <i className="fa fa-edit"></i>
                </button>
            </Card>

            <Modal
                show={modalShow}
                onHide={() => {
                    setTitle(special.title);
                    setDescription(special.description);
                    setUploadPreview(special.url);
                    setModalShow(false);
                }}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Edit Item
                    </Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Card>

                        <Modal.Body>

                            <Card.Img variant="top" src={uploadPreview}
                                style={{
                                    opacity: 0.8
                                }}
                            />
                            <input id={`upload-special-${special.specialID}`} type="file" className="form-control border-0 d-none"
                                onChange={uploadOnChange}
                            />
                            <label className="btn btn-lg btn-warning rounded-circle edit-btn" htmlFor={`upload-special-${special.specialID}`} style={{
                                borderRadius: 0
                            }}>
                                <i className="fa fa-edit"></i>
                            </label>

                            <Card.Body>

                                <div className="d-flex flex-column">
                                    <p className="fw-bold m-0 mb-2">Title</p>
                                    <div>
                                        <input
                                            name="title"
                                            type="text" className="form-control m-0"
                                            defaultValue={title}
                                            {...register("title")}
                                            required
                                            onChange={editChange}
                                        />
                                    </div>
                                </div>

                                <div className="d-flex flex-column mt-3">
                                    <p className="fw-bold m-0 mb-2">Description</p>
                                    <div>
                                        <textarea
                                            name="description"
                                            type="text" className="form-control m-0"
                                            defaultValue={description}
                                            style={{
                                                minHeight: 150,
                                                maxHeight: 150,
                                                overflow: 'scroll'
                                            }}
                                            {...register("description")}
                                            required
                                            onChange={editChange}
                                        />
                                    </div>
                                </div>
                            </Card.Body>
                        </Modal.Body>

                    </Card>
                    <Modal.Footer>
                        {
                            editLoading
                                ?
                                <button className="btn btn-success w-100 disabled d-flex align-items-center justify-content-center">
                                    <span className="m-0">Loading</span>
                                    <Spinner className="m-0 ms-2" animation="border" size="sm" />
                                </button>
                                :

                                canApply
                                    ?
                                    <button type="submit" className="btn btn-success w-100">
                                        Apply Changes <FontAwesomeIcon icon={faCircleCheck} />
                                    </button>
                                    :
                                    <button type="submit" className="btn btn-secondary w-100 disabled btn-not"
                                    >
                                        Nothing to change
                                    </button>

                        }
                    </Modal.Footer>
                </Form>
            </Modal>



        </Col >
    );
};

export default DashboardSpecial;